import {createSlice} from '@reduxjs/toolkit'

export const sessionSlice = createSlice({
    name: 'auth/session',
    initialState: {
        accessToken: '',
        signedIn: false,
    },
    reducers: {
        onSignInSuccess: (state, action) => {
            state.accessToken = action.payload.accessToken || ''
            state.signedIn = Boolean(state.accessToken)
        },
        onSignOutSuccess: (state) => {
            state.signedIn = false
            state.accessToken = ''
        },
        setAccessToken: (state, action) => {
            state.accessToken = action.payload.accessToken || ''
            state.signedIn = Boolean(state.accessToken)
        },
    },
})

export const {onSignInSuccess, onSignOutSuccess, setAccessToken} = sessionSlice.actions

export default sessionSlice.reducer
